import packageInfo from '@/package.json';
import { Component, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgSelectConfig } from '@ng-select/ng-select';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  private config = inject(NgSelectConfig);

  appVersion: any;
  date?: Date;

  constructor() {
    this.config.appendTo = 'body';
  }

  ngOnInit() {
    this.date = new Date();
    this.appVersion = packageInfo.version;
  }
}
